module.exports = __webpack_public_path__ + "images/shoebox-bad8d612642db173a760e2f9762ef576.svg";